export enum ProgramType {
  DAY = "day",
  NIGHT = "night",
}
